import { ComplaintCount } from '../../models/ComplaintCount';
import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';

interface UpdateComplaintCountState extends ApiState {
  complaintCount?: ComplaintCount
}

export default requestReducer<UpdateComplaintCountState>('UPDATE_COMPLAINT_COUNT')